import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormHelperText,
  Autocomplete,
  Typography,
  Paper,
  TableContainer,
  TableBody,
  Table,
  Tooltip,
  TableRow,
  TableCell,
} from "@mui/material";
import {
  styled,
  Popper,
} from "@mui/material";
import moment from "moment";
import { GridCloseIcon } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { useRef } from "react";
import DraftsIcon from "@mui/icons-material/Drafts";
import useGlobalState from "../../Context";
import DeleteIcon from "@mui/icons-material/Delete";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const UploadServiceAdvisory = (props) => {
  const {
    openDialog,
    handleClose,
    register,
    handleSubmit,
    errors,
    modelList,
    allBrands,
    setValue,
    releaseDate,
    setReleaseDate,
    onUploadSubmit,
    setFile,
    onBrickSelect,
    handleChange,
    sendNotification,
    disableBrickDropdown,
    disableModelDropdown,
    isEditMode,
    formData,
    onBrandSelectedClick,
    onCategoryClickInModel,
    setSelectedModelIds,
    setSelectedDeptlIds,
    departmentList,
    clearErrors,
    disableCategoryDropdown,
    disableFamilyDropdown,
    onFamilyClick,
    productFamilyList,
    categoryListOnBrandId,
    brickList,
    docTypeList,
    handleChangeDraft,
    draftCheck,
    deptIdData,
    file,
    modelIdData,
    selectedModelIds,
    selectedDeptIds,
    setCurrentError,
    setErrorDate,
    currentError,
    errorDate,
    existingFiles
  } = props;

  const { content } = brickList;
  const [productCategoryId, setProductCategoryId] = useState(
    formData?.categoryId ?? null
  );
  const [productCatFamilyMappingId, setProductCatFamilyMappingId] = useState(
    formData?.productFamilyId ?? null
  );
  const [brickIdVal, setBrickId] = useState(formData?.brickId ?? null);
  const [brandName_Adv, setBrandName_Adv] = useState("");
  const [type_Adv, setType_Adv] = useState("");
  const [famName_Adv, setFamName_Adv] = useState("");
  const [year_Adv, setYear_Adv] = useState("");
  const [date_Adv, setDate_Adv] = useState("");
  const [{ auth }] = useGlobalState();
  const userDept = auth.ldapParam.department;
  const autoC = useRef(null);
  const autoC1 = useRef(null);
  const [value, setDValue] = useState(null);
  const [dAdvisoryNumber, setdAdvisoryNumber] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([])
  
  const handleDChange = (newValue) => {
    setDValue(newValue);
  };
  const [deptValue, setDeptValue] = React.useState([]);
  const [modelValue, setModelValue] = React.useState([]);
  const [checkAll, setCheckAll] = React.useState(false);
  const [checkAllDepartment, setCheckAllDepartment] = React.useState(false);
  const PopperStyledComponent = styled(Popper)(({ theme }) => ({
    border: `1px solid ${
      theme.palette.mode === "light" ? "rgba(149, 157, 165, 0.2)" : "rgb(1, 4, 9)"
    }`
  }));
  const checkAllModel = (event) => {
    setCheckAll(event.target.checked);
    modelIdData.length=0;
    clearErrors("model_id");
    if (event.target.checked) {
      modelList.map((d) => {
      modelIdData.push(d);});
      setValue("model_id", modelIdData);
      setSelectedModelIds(modelIdData);
      setModelValue(modelIdData)
    } else {
      setValue("model_id", []);
      setSelectedModelIds([]);
      setModelValue([])
    }
  };
  const checkAllDept = (event) => {
    setCheckAllDepartment(event.target.checked);
    deptIdData.length=0;
    clearErrors("dept_Id");
    if (event.target.checked) {
      departmentList.map((d) => {
      deptIdData.push(d);});
      setValue("dept_Id", deptIdData);
      setSelectedDeptlIds(deptIdData);
      setDeptValue(deptIdData);
    } else {
      setValue("dept_Id", []);
      setSelectedModelIds([]);
      setDeptValue([]);
    }
  };

  useEffect(() => {
    if(!isEditMode)
    setdAdvisoryNumber('');
    setCurrentError(null);
    setErrorDate(false);
    setValue(
      "advisoryNumber",
      `${userDept ?? ""}-${brandName_Adv ?? ""}${type_Adv ?? ""}/${famName_Adv ??""}/${date_Adv?? ""}${year_Adv ?? ""}${dAdvisoryNumber ?? ""}`
    );
  }, [userDept, brandName_Adv, type_Adv,famName_Adv, date_Adv, year_Adv,dAdvisoryNumber]);

  useEffect(() => {
    setUploadedFiles([]);
    setProductCategoryId(formData?.categoryId);
    setProductCatFamilyMappingId(formData?.productFamilyId);
    setBrickId(formData?.brickId);
    let myDate = new Date();;
    let year = myDate.getFullYear().toString().substr(-2);
    let _date = (myDate.getMonth() + 1).toString().padStart(2, "0");
    setYear_Adv(year);
    setDate_Adv(_date);
    let brandName = formData.brandName??'';
    brandName.substring(0, 1);
    setBrandName_Adv(brandName.substring(0, 1));
    var advType = formData.docTypeDescription??'';
    setType_Adv(advType.includes("Bulletin")?"B":"A")
		setFamName_Adv(formData.brickCode ??'')
    let advNum = formData.advisoryNumber; 
    if(advNum && advNum.length >0)
      setdAdvisoryNumber("/"+advNum.substr(advNum.length - 4))
    setDeptValue(deptIdData);
    setModelValue(modelIdData)
    setCheckAllDepartment(false);
    setCheckAll(false);
    setUploadedFiles(existingFiles);
     }, [openDialog, isEditMode, existingFiles]);

  const clearBrand = async (autoC) => {
    const ele = autoC.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator"
    )[0];
    if (ele) ele.click();
  };

 const handleFileEvent= (e)=>{
    handleUploadFiles( Array.prototype.slice.call(e.target.files));
 };
 const handleUploadFiles= (fileList)=>{
  const uploaded = [...uploadedFiles];
  fileList.some( (file) => {
    if(uploaded.findIndex ((f)=> f.name === file.name) === -1){
    uploaded.push(file);
    }
  });
  setUploadedFiles(uploaded);
  setFile(uploaded);
  };
 const unSelectFile = (fileName)=>{
  const filteredFiles = uploadedFiles?.filter((file) => file.name != fileName);
  setUploadedFiles(filteredFiles);
  setFile(filteredFiles);
 };
  return (
    <>
      <Dialog open={(openDialog)} onClose={handleClose}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{isEditMode ? "Edit" : "Upload"} Service Advisory</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={() => {
                handleClose();
              }}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 4, pb: 0 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center">
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sm={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Brand
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Select Category"
                            name="brandId"
                            fullWidth
                            size="small"
                            autoComplete="off"
                            defaultValue={formData.brandId}
                            {...register("brandId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.brandId)}
                            helperText={errors?.brandId?.message}>
                            {allBrands &&
                              allBrands.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brandId}
                                    sx={{ width: "100%" }}
                                    value={d.brandId}
                                    size="small"
                                    onClick={() => {
                                      onBrandSelectedClick(d.brandId, d.name);
                                      setProductCategoryId(null);
                                      setBrickId(null);
                                      setProductCatFamilyMappingId(null);
                                      let brandName = d.name;
                                      brandName.substring(0, 1);
                                      setBrandName_Adv(brandName.substring(0, 1));
                                      clearBrand(autoC);
                                      setValue("brickId", null);
                                    }}>
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brandId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Category
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Product Category"
                            name="productCategoryId"
                            fullWidth
                            size="small"
                            value={productCategoryId ?? null}
                            autoComplete="off"
                            {...register("productCategoryId", {
                              required: "This field is required",
                            })}
                            disabled={disableCategoryDropdown}
                            error={Boolean(errors?.productCategoryId)}
                            helperText={errors?.productCategoryId?.message}
                            onChange={(e) => {
                              setProductCategoryId(e.target.value);
                            }}>
                            {categoryListOnBrandId &&
                            categoryListOnBrandId.length > 0 ? (
                              categoryListOnBrandId?.map((d) => {
                                return (
                                  <MenuItem
                                    key={d?.productCategoryId}
                                    sx={{ width: "100%" }}
                                    value={d?.productCategoryId}
                                    size="small"
                                    onClick={(e) => {
                                      onCategoryClickInModel(
                                        d?.productCategoryId,
                                        d?.name
                                      );
                                      setBrickId(null);
                                      setProductCatFamilyMappingId(null);
                                    }}>
                                    {d?.name}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem>Record not found</MenuItem>
                            )}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.productCategoryId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Segment-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Family
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="productCatFamilyMappingId"
                            label="Product Family"
                            fullWidth
                            
                            value={
                              productCatFamilyMappingId ??
                              formData?.productCatFamilyMappingId ??
                              null
                            }
                            size="small"
                            autoComplete="off"
                            {...register("productCatFamilyMappingId", {
                              required: "This field is required",
                            })}
                            disabled={disableFamilyDropdown}
                            error={Boolean(errors?.productCatFamilyMappingId)}
                            helperText={
                              errors?.productCatFamilyMappingId?.message
                            }
                            onChange={(e) => {
                              setProductCatFamilyMappingId(e.target.value);
                            }}>
                            {productFamilyList?.content &&
                              productFamilyList?.content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.productCatFamilyMappingId}
                                    sx={{ width: "100%" }}
                                    value={d.productCatFamilyMappingId}
                                    size="small"
                                    onClick={(e) => {
                                      onFamilyClick(
                                        d.productCatFamilyMappingId,
                                        d.productFamilyName
                                      );
                                      setBrickId(null);
                                    }}>
                                    {d.productFamilyName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors &&
                              errors?.productCatFamilyMappingId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Brick-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Brick
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="brickId"
                            label="Brick"
                            fullWidth
                            value={brickIdVal ?? formData?.brickId ?? null}
                            size="small"
                            disabled={disableBrickDropdown}
                            autoComplete="off"
                            {...register("brickId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.brickId)}
                            helperText={errors?.brickId?.message}
                            onChange={(e) => {
                              setBrickId(e.target.value);
                            }}>
                            {content &&
                              content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brickId}
                                    sx={{ width: "100%" }}
                                    value={d.brickId}
                                    size="small"
                                    onClick={(e) => {
                                      onBrickSelect(d.brickId);
                                      setFamName_Adv(d.brickCode);
                                    }}>
                                    {d.brickName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brickId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sm={6} sx={{ pr: 1 }}>
                        <Autocomplete
                          multiple
                          limitTags={1}
                          id="checkboxes-tags-demo"
                          name="model_id"
                          options={modelList ?? []}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option?.description}
                          value={modelValue}
                          defaultChecked={modelIdData}
                          disabled={disableModelDropdown}
                          {...register("model_id", {
                            required: "This field is required",
                          })}
                          ref={autoC}
                          onBlur ={(event, newValue, reason) => {
                            setValue("model_id", selectedModelIds);
                          }}
                          error={Boolean(errors?.model_id)}
                          helperText={errors?.model_id?.message}
                          onChange={(event, newValue, reason) => {
                            if (reason === "selectOption") {
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setModelValue(newValue)
                            } else if (reason === "removeOption") {
                              setCheckAll(false);
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setModelValue(newValue)
                            } else if (reason === "clear") {
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setCheckAll(false);
                              setModelValue([])
                            }
                          }}
                          size="small"
                          PopperComponent={(param) => (
                            <PopperStyledComponent {...param}>
                              <Box
                                sx={{
                                  backgroundColor: "white",
                                  height: "40px",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                <Checkbox
                                  checked={checkAll}
                                  onChange={checkAllModel}
                                  id="check-all"
                                  size="small"
                                  sx={{ marginRight: "8px" }}
                                  onMouseDown={(e) => e.preventDefault()}
                                />
                                Select All
                              </Box>
                              <Box {...param} />
                            </PopperStyledComponent>
                          )}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 , marginLeft: -15 , marginBlock: -50}}
                                checked={selected || checkAll}
                              />
                              {option?.fgCode + " -" + option?.description}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={Boolean(errors?.model_id)}
                              helperText={errors?.model_id?.message}
                              label="Model"
                              placeholder="select Model"
                            />
                          )}
                        />
                          {isEditMode ? (setValue("model_id", modelIdData)):""}
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Is Downloadable?
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Is Downloadable?"
                            name="isDownloadAble"
                            fullWidth
                            defaultValue={formData.isDownloadable}
                            size="small"
                            autoComplete="off"
                            {...register("isDownloadAble")}>
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={1}
                              size="small">
                              Yes
                            </MenuItem>
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={0}
                              size="small">
                              No
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Select Type
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Select Type"
                            name="typeId"
                            fullWidth
                            size="small"
                            autoComplete="off"
                            defaultValue={formData.docTypeId}
                            {...register("typeId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.typeId)}
                            helperText={errors?.typeId?.message}
                          >
                            {docTypeList &&
                              docTypeList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.id}
                                    sx={{ width: "100%" }}
                                    value={d.id}
                                    size="small"
                                    onClick={(e) => {
                                      let advType = d.description;
                                      setType_Adv(advType.includes("Bulletin")?"B":"A")
                                    }}>
                                    {d.description}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.typeId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Autocomplete
                            name="dept_Id"
                            fullWidth
                            multiple
                            limitTags={1}
                            id="checkboxes-tags-demo"
                            options={departmentList ?? []}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option?.name}
                            value = { deptValue}
                            
                            onBlur ={(event, newValue, reason) => {
                              setValue("dept_Id", selectedDeptIds);
                            }}
                            error={Boolean(errors?.dept_Id)}
                            helperText={errors?.dept_Id?.message}
                            onChange={async (event, newValue, reason) => {
                              if (reason === "selectOption") {
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setDeptValue(newValue);
                              } else if (reason === "removeOption") {
                                setCheckAllDepartment(false);
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setDeptValue(newValue);
                              } else if (reason === "clear") {
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setCheckAllDepartment(false);
                                setDeptValue([]);
                              }
                            }}
                            size="small"
                            PopperComponent={(param) => (
                              <PopperStyledComponent {...param}>
                                <Box
                                  sx={{
                                    backgroundColor: "white",
                                    height: "40px",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  <Checkbox
                                    checked={checkAllDepartment}
                                    onChange={checkAllDept}
                                    id="check-all-department"
                                    size="small"
                                    sx={{ marginRight: "8px" }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  />
                                  Select All
                                </Box>
                                <Box {...param} />
                              </PopperStyledComponent>
                            )}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 , marginLeft: -15 , marginBlock: -50}}
                                  checked={selected || checkAllDepartment}
                                />
                                {option?.name}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Department"
                                placeholder="select department"
                                error={Boolean(errors?.dept_Id)}
                                helperText={errors?.dept_Id?.message}
                              />
                            )}
                          />
                           {isEditMode ? ( setValue("dept_Id", deptIdData)):"" }
                        </FormControl>
                      </Grid>
                      <Grid container>
                        <Grid item xs={6} sm={6} sx={{ mt: 1, pr: 1 }}>
                          <TextField
                            className="stepperFormInput"
                            label="Short Description"
                            name="serviceAdvDesc"
                            placeholder="Enter short description"
                            fullWidth
                            required
                            size="small"
                            autoComplete="off"
                            {...register("serviceAdvDesc", {
                              required: "This field is required",
                              pattern: {
                                value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^{}<>\n]+$/,
                                message: "Field can not start with special characters and exlclude {}<>",
                              },
                              maxLength: {
                                value: 250,
                                message: "Max length should be 250 only",
                              },
                            })}
                            error={Boolean(errors?.serviceAdvDesc)}
                            helperText={errors?.serviceAdvDesc?.message}
                           />
                          <Typography
                            sx={{
                              fontSize: "8px",
                              color: "#909090",
                              textAlign: "right",
                            }}>
                            max 250 characters
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sx={{ mt: 1 }}>
                          <TextField
                            className="stepperFormInput"
                            label="Advisory Number"
                            name="advisoryNumber"
                            fullWidth
                            placeholder="Enter advisory number"
                            size="small"
                            autoComplete="off"
                            disabled
                            value={`${userDept ?? ""}-${brandName_Adv ?? ""}${type_Adv ?? ""}/${famName_Adv ??""}/${date_Adv?? ""}${year_Adv ?? ""}${dAdvisoryNumber ?? ""}`}
                            InputLabelProps={{ shrink: true }}
                           
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 0 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            disabled={draftCheck}
                            name="appointmentDate"
                            sx={{ innerHeight: 2 }}
                            label="Release Date"
                            minDate={new Date()}
                            value={
                               releaseDate
                            }
                           ref={autoC1}
                            onChange={(newValue) => {
                              setReleaseDate(newValue);
                              handleDChange();
                              setCurrentError(null);
                              setErrorDate(false);
                            }}
                            onError={(reason, value) => {
                              if (reason == "minDate") {
                               // setCurrentError("Date should be greater then current date");
                               // setErrorDate(true);
                              } else if (reason) {
                                setCurrentError(reason);
                                setErrorDate(true);
                              } else {
                                setCurrentError(null);
                                setErrorDate(false);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                              required
                                {...params}
                                error={errorDate}
                                helperText={currentError ?? currentError}
                                sx={{ width: "100%" }}
                                size="small"
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid
                        item
                        xs={0}
                        sx={{
                          pr: 1,
                          color: "#003f93",
                          mb: 2,
                        }}>
                        <DraftsIcon sx={{ mr: 1 }} />
                        Draft
                        <Checkbox
                          checked={draftCheck}
                          onChange={handleChangeDraft}
                          inputProps={{ "aria-label": "controlled" }}
                          name="draftedCheck"
                           disabled={formData.releaseDate < moment(new Date()).format("YYYY-MM-DD")}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 0 }}>
                      <Grid item xs={3} sx={{ pr: 0 }} >
                        <input
                          type="file"
                          multiple
                          accept="application/pdf, .docx,.doc, .ppt, .pptx, .xlsx,.xls, .csv"
                          id="upload-button"
                          style={{ width: "240px",color: "transparent" }}
                          title=""
                          onChange={(e)=>handleFileEvent(e)}
                        />
                     </Grid>

                        <Grid item xs={9} sx={{ mt: 0 }}>
                          <Paper>
                            <TableContainer>
                              <Table>
                                <TableBody>
                                { uploadedFiles?.map( (f, index)=>{ setFile(uploadedFiles);
                                  return (
                                    <TableRow>
                                      <TableCell >{index+1}</TableCell>
                                      <TableCell> {f.name}</TableCell>
                                      <TableCell> 
                                        <Tooltip title="Remove">
                                          <DeleteIcon
                                            sx={{
                                            fontSize: "20px",
                                            cursor: "pointer",
                                            color: "#567aac",
                                            height: "18px",
                                            width: "18px",
                                            }}
                                            onClick={() =>
                                            unSelectFile(f.name)
                                            }
                                          />
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  ); })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                     
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 0 }}>
                      <Grid
                        item
                        xs={6}
                        sx={{
                          pr: 1,
                          color: "#003f93",
                          mb: 0,
                        }}>
                        <NotificationsActiveIcon> </NotificationsActiveIcon>{" "}
                        Send Notification
                        <Checkbox
                          checked={sendNotification}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "controlled" }}
                          name="askRefer"
                          disabled={draftCheck}
                        />
                      </Grid>
                      {sendNotification ? (
                        <TextField
                          className="stepperFormInput"
                          label="Notification Description"
                          name="notificationDes"
                          fullWidth
                          required
                          disabled={draftCheck}
                          size="small"
                          autoComplete="off"
                          {...register("notificationDes", {
                            required: "This field is required",
                            pattern: {
                              value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^{}<>\n]+$/,
                              message: "Field can not start with special characters and exlclude {}<>",
                            },
                            minLength: {
                              value: 3,
                              message: "Min length should be 3 only",
                            },
                            maxLength: {
                              value: 2000,
                              message: "Max length should be 2000 only",
                            },
                          })}
                          error={Boolean(errors?.notificationDes)}
                          helperText={errors?.notificationDes?.message}
                          onBlur={(e) => {
                            let str = e.target.value;
                            setValue("notificationDes", str.trim());
                          }}
                        />
                      ) : null}
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box
                sx={{
                  display: "block",
                  textAlign: "right",
                  p: 1,
                  pb: 1,
                  mt: 0,
                }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onUploadSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained">
                  Save
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained">
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default UploadServiceAdvisory;
